import Text from '../Common/NewText'

const Progressbar = ({
  parameter,
  rating,
  color,
}: {
  parameter?: string
  rating: string
  color: string
}) => {
  const calculatedRating = Math.round(Number(rating.slice(0, -1)))

  return (
    <div className="flex w-full items-center justify-between md:justify-start">
      <div className="w-[calc(100%-90px)]">
        <div className="bg-brand-grey-background h-[10px] rounded">
          {calculatedRating !== 0 && (
            <div
              className="h-full rounded"
              style={{
                width: `${calculatedRating}%`,
                backgroundColor: color,
              }}
            >
              {' '}
            </div>
          )}
        </div>{' '}
      </div>
      <div className="flex max-w-[90px] items-center justify-between">
        <Text appearance="caption" addClassName="text-brand-grey-dark ml-2">
          {rating}
        </Text>
        {parameter && (
          <Text appearance="caption" addClassName="text-brand-grey-dark ml-2">
            {parameter}
          </Text>
        )}
      </div>
    </div>
  )
}

export default Progressbar
